import {
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Skeleton,
	Stack,
	Text
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import api from "../../services/api";
import DataTableIndicadores from "./DataTableIndicadores";

type IndicadorData = {
	id: string;
	nome: string;
	cid: string
	doc: string;
	phone: string;
	comissao: number;
}

interface ModalIndicadoresParams {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
}

const ModalIndicadores: React.FC<ModalIndicadoresParams> = ({ 
	isOpen,
	onRequestClose
}) => {
	const [indicadores, setIndicadores] = useState<IndicadorData[]>([]);

	useEffect(() => {
		api.get('controle/indicadores')
			.then(response => {
				setIndicadores(response.data);
			})
	}, []);

	return (
		<Modal
			isCentered={true}
			size="3xl"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />

			<ModalContent mt={["500px", "20px"]}>
				<ModalCloseButton />

				<ModalHeader mb="0" pb="0">
					<Text>Escolher Indicador</Text>
				</ModalHeader>

				<ModalBody mt="2">
					<Flex
						w="100%"
						bg="gray.100"
						py="2"
						px="4"
						my="4"
						align="center"
						borderRadius={20}
					>
						{ indicadores.length > 0 ? (
							<DataTableIndicadores data={indicadores} onRequestClose={onRequestClose} />
						) : (
							<Stack spacing="4" w="100%">
								<Skeleton borderRadius="full" w="50%" h="40px" />
								<Skeleton borderRadius="full" w="100%" h="40px" />
								<Skeleton borderRadius="full" w="100%" h="40px" />
								<Skeleton borderRadius="full" w="100%" h="40px" />
								<Skeleton borderRadius="full" w="100%" h="40px" />
								<Skeleton borderRadius="full" w="100%" h="40px" />
							</Stack>
						)}
					</Flex>
				</ModalBody>

				<ModalFooter pt="0" mt="0">
					<Button colorScheme="blue" type="submit">Salvar</Button>

					<Button
						colorScheme="blackAlpha"
						ml="4"
						onClick={() => onRequestClose(false)}
					>
						Cancelar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default ModalIndicadores;